<template>
  <div v-if="dataTableservices!=null && dataTableservices.remark!=null">
    <div class="show-content show-content-remark">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-12 col-md-12">
                    <p class="text-h">หมายเหตุ</p>
                    <div v-html="dataTableservices.remark.remarks"></div>
                </div>
            </div>
        </div>
    </div>

    <!-- <div class="service-periodical-btn-back">
      <div class="container">
        <div class="btn btn-secondary btn-arrow btn-arrow-left">
            <span>
              <img :src="asset('images/chevron-left-white.svg')" alt="" />ย้อนกลับ
            </span>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
    export default {
        data() {
            return {

            }
        },
        props: {
          dataTableservices: {
              type: Object,
              default: null
          }
        },
        methods: {
            //You can use !! (Double Negation). Its safer and it will check both null and undefined.
            chkValueError(value){
                if( !!value ){
                    value = '';
                }
                return value;
            },
        },
        computed: {

        },
    }
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// resources/js/components/service/Remark.vue